export default __webpack_public_path__ + "static/media/PlayStore.c27feb95.png";